module.exports = __webpack_public_path__ + "img/icon-round-twitter.012aed74.svg";